import React from 'react';
import './DataTable.css';

/**
 * Reusable data table component for displaying tabular data
 * @param {Array} columns - Array of column names
 * @param {Array} rows - Array of row data (each row is an array of values)
 * @param {number} maxRows - Maximum number of rows to display (optional)
 * @param {string} className - Additional CSS class name (optional)
 */
const DataTable = ({ columns = [], rows = [], maxRows, className = '' }) => {
  const displayRows = maxRows ? rows.slice(0, maxRows) : rows;

  if (!columns.length || !rows.length) {
    return (
      <div className="data-table-empty">
        No data available
      </div>
    );
  }

  return (
    <div className={`data-table-wrapper ${className}`}>
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((row, rIdx) => (
            <tr key={rIdx}>
              {columns.map((_, cIdx) => (
                <td key={cIdx}>{row[cIdx] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;

